// /src/components/FichesList.jsx
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import FicheEditForm from './FicheEditForm';
import { PracticalSheet } from './PracticalSheet';

export default function FichesList() {
  const [fiches, setFiches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchFiches();
  }, []);

  async function fetchFiches() {
    setLoading(true);
    const { data, error } = await supabase
      .from('fiches_pratiques')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Erreur Supabase :', error);
      setMessage('Erreur lors du chargement.');
      setFiches([]);
    } else {
      setFiches(data || []);
    }
    setLoading(false);
  }

  async function handleDelete(id) {
    const confirmed = window.confirm('Voulez-vous vraiment supprimer cette fiche ?');
    if (!confirmed) return;

    const { error } = await supabase.from('fiches_pratiques').delete().eq('id', id);
    if (error) {
      setMessage('Erreur lors de la suppression.');
      console.error(error);
    } else {
      setMessage('✅ Fiche supprimée.');
      fetchFiches();
    }
  }

  if (loading) return <p>Chargement des fiches...</p>;

  if (editId) {
    return (
      <FicheEditForm
        ficheId={editId}
        onFinish={() => {
          setEditId(null);
          fetchFiches();
        }}
      />
    );
  }

  return (
    <div className="space-y-6">
      {message && <p className="text-sm text-green-600">{message}</p>}

      {fiches.map((fiche) => (
        <div key={fiche.id} className="relative border p-4 rounded-xl bg-white shadow">
          <PracticalSheet
            title={fiche.title}
            icon={fiche.icon}
            description={fiche.description}
            steps={fiche.steps}
            relatedLinks={fiche.related_links}
          />
          <div className="mt-2 flex gap-4 text-sm">
            <button onClick={() => setEditId(fiche.id)} className="text-blue-600 underline">
              ✏️ Modifier
            </button>
            <button onClick={() => handleDelete(fiche.id)} className="text-red-600 underline">
              🗑️ Supprimer
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
